import { Spin } from 'design-system';

// ----------------------------------------------------------------------

export default function LoadingScreen({ style }: { style?: React.CSSProperties }) {
  return (
    <div
      style={{
        padding: '0 40px',
        width: '100%',
        flexGrow: 1,
        minHeight: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}
    >
      <Spin size="large" />
    </div>
  );
}
